// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Avatar_avatar-container__PJ02A {
  position: relative;
}
.Avatar_avatar-container__default__kzqxs {
  min-width: 32px;
  width: 32px;
  height: 32px;
}
.Avatar_avatar-container__small__UDJLp {
  min-width: 24px;
  width: 24px;
  height: 24px;
}
.Avatar_avatar-container__medium__Kud1R {
  min-width: 32px;
  width: 32px;
  height: 32px;
}
.Avatar_avatar-container__large__PUdex {
  min-width: 40px;
  width: 40px;
  height: 40px;
}
.Avatar_avatar-container__xlarge__scjaU {
  min-width: 68px;
  width: 68px;
  height: 68px;
}
.Avatar_avatar-container__xxlarge__ijpMP {
  min-width: 96px;
  width: 96px;
  height: 96px;
}
.Avatar_avatar-container__PJ02A::after {
  content: "";
  width: calc(100% - 1.5px);
  height: calc(100% - 1.5px);
  position: absolute;
  top: -1px;
  left: -1px;
  border: 2px solid var(--border-color-avatar, transparent);
  border-radius: 50%;
}
.Avatar_avatar-container__PJ02A img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.Avatar_avatar-container__PJ02A:not(.Avatar_avatar-container--square__EJjv7) img {
  border-radius: 50%;
}
.Avatar_avatar-container__initials__\\+ZS5r {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 500;
  font-size: 1rem;
  border-radius: 50%;
  box-sizing: border-box;
  letter-spacing: 1px;
}
.Avatar_avatar-container__initials--default__ATmk9 {
  font-size: 13px;
}
.Avatar_avatar-container__initials--small__4SFZx {
  font-size: 11px;
}
.Avatar_avatar-container__initials--medium__3qtJp {
  font-size: 13px;
}
.Avatar_avatar-container__initials--large__\\+FKMv {
  font-size: 16px;
}
.Avatar_avatar-container--square__EJjv7 img {
  border-radius: 4px;
}
.Avatar_avatar-container--square__EJjv7::after {
  border-radius: 4px;
}
.Avatar_avatar-container--square__EJjv7 .Avatar_avatar-container__initials__\\+ZS5r {
  border-radius: 4px;
}
.Avatar_avatar-container__status__S2kXo {
  width: 10px;
  height: 10px;
  background-color: #fff;
  border-radius: 50%;
  position: absolute;
  right: -2px;
  bottom: -2px;
  padding: 7px;
}
.Avatar_avatar-container__status--offline__Iahnn::before {
  content: "";
  width: 5px;
  height: 5px;
  position: absolute;
  top: 2px;
  left: 2px;
  border: 3px solid var(--m-subtle-xxbolder);
  border-radius: 50%;
}
.Avatar_avatar-container__status--online__bSncU::before {
  content: "";
  width: 10px;
  height: 10px;
  position: absolute;
  top: 2px;
  left: 2px;
  background-color: var(--m-success);
  border-radius: 50%;
}
.Avatar_avatar-container__edit__4GQNZ {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: ease-in-out 0.2s;
}
.Avatar_avatar-container__edit__4GQNZ svg {
  font-size: 24px;
  color: #fff;
  opacity: 0;
}
.Avatar_avatar-container__PJ02A:hover .Avatar_avatar-container__edit__4GQNZ {
  background-color: rgba(0, 0, 0, 0.3);
}
.Avatar_avatar-container__PJ02A:hover .Avatar_avatar-container__edit__4GQNZ svg {
  opacity: 1;
}`, "",{"version":3,"sources":["webpack://./src/components/CustomUI/Avatar/Avatar.module.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;AACJ;AACI;EACI,eAAA;EACA,WAAA;EACA,YAAA;AACR;AAEI;EACI,eAAA;EACA,WAAA;EACA,YAAA;AAAR;AAGI;EACI,eAAA;EACA,WAAA;EACA,YAAA;AADR;AAII;EACI,eAAA;EACA,WAAA;EACA,YAAA;AAFR;AAKI;EACI,eAAA;EACA,WAAA;EACA,YAAA;AAHR;AAKI;EACI,eAAA;EACA,WAAA;EACA,YAAA;AAHR;AAMI;EACI,WAAA;EACA,yBAAA;EACA,0BAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,yDAAA;EACA,kBAAA;AAJR;AAOI;EACI,WAAA;EACA,YAAA;EAEG,iBAAA;AALX;AAUQ;EACI,kBAAA;AARZ;AAYI;EACI,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,sBAAA;EACA,mBAAA;AAVR;AAYQ;EACG,eAAA;AAVX;AAaQ;EACI,eAAA;AAXZ;AAcQ;EACG,eAAA;AAZX;AAeQ;EACI,eAAA;AAbZ;AAkBQ;EACI,kBAAA;AAhBZ;AAmBQ;EACI,kBAAA;AAjBZ;AAoBQ;EACI,kBAAA;AAlBZ;AAsBI;EACI,WAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;AApBR;AAuBY;EACI,WAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,0CAAA;EACA,kBAAA;AArBhB;AA0BY;EACI,WAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,kCAAA;EACA,kBAAA;AAxBhB;AA6BI;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,MAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,4BAAA;AA3BR;AA6BQ;EACI,eAAA;EACA,WAAA;EACA,UAAA;AA3BZ;AAiCQ;EACI,oCAAA;AA/BZ;AAiCY;EACI,UAAA;AA/BhB","sourcesContent":[".avatar-container {\n    position: relative;\n   \n    &__default {\n        min-width: 32px;\n        width: 32px;\n        height: 32px;\n    }\n\n    &__small {\n        min-width: 24px;\n        width: 24px;\n        height: 24px;\n    }\n\n    &__medium {\n        min-width: 32px;\n        width: 32px;\n        height: 32px;\n    }\n    \n    &__large {\n        min-width: 40px;\n        width: 40px;\n        height: 40px;\n    }\n\n    &__xlarge {\n        min-width: 68px;\n        width: 68px;\n        height: 68px;\n    }\n    &__xxlarge {\n        min-width: 96px;\n        width: 96px;\n        height: 96px;\n    }\n\n    &::after {\n        content: '';\n        width: calc(100% - 1.5px);\n        height: calc(100% - 1.5px);\n        position: absolute;\n        top: -1px;\n        left: -1px;\n        border: 2px solid var(--border-color-avatar, transparent);\n        border-radius: 50%;\n    }\n    \n    img {\n        width: 100%;\n        height: 100%;\n        -o-object-fit: cover;\n           object-fit: cover;\n\n    }\n\n    &:not(.avatar-container--square) {\n        img {\n            border-radius: 50%;\n        }\n    }\n\n    &__initials {\n        width: 100%;\n        height: 100%;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        font-weight: 500;\n        font-size: 1rem;\n        border-radius: 50%;\n        box-sizing: border-box;\n        letter-spacing: 1px;\n\n        &--default {\n           font-size: 13px;\n        }\n    \n        &--small {\n            font-size: 11px;\n        }\n    \n        &--medium {\n           font-size: 13px;\n        }\n        \n        &--large {\n            font-size: 16px;\n        }\n    }\n\n    &--square {\n        img {\n            border-radius: 4px;\n        }\n\n        &::after {\n            border-radius: 4px;\n        }\n\n        .avatar-container__initials {\n            border-radius: 4px;\n        }\n    }\n\n    &__status {\n        width: 10px;\n        height: 10px;\n        background-color: #fff;\n        border-radius: 50%;\n        position: absolute;\n        right: -2px;\n        bottom: -2px;\n        padding: 7px;\n\n        &--offline {\n            &::before {\n                content: '';\n                width: 5px;\n                height: 5px;\n                position: absolute;\n                top: 2px;\n                left: 2px;\n                border: 3px solid var(--m-subtle-xxbolder);\n                border-radius: 50%;\n            }\n        }\n\n        &--online {\n            &::before {\n                content: '';\n                width: 10px;\n                height: 10px;\n                position: absolute;\n                top: 2px;\n                left: 2px;\n                background-color: var(--m-success);\n                border-radius: 50%;\n            }\n        }\n    }\n\n    &__edit {\n        width: 100%;\n        height: 100%;\n        position: absolute;\n        top: 0;\n        border-radius: 50%;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        transition: ease-in-out .2s;\n        \n        svg {\n            font-size: 24px;\n            color: #fff;\n            opacity: 0;\n        }\n\n    }\n    \n    &:hover {\n        .avatar-container__edit {\n            background-color: rgba($color: #000000, $alpha: 0.3);\n    \n            svg {\n                opacity: 1;\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"avatar-container": `Avatar_avatar-container__PJ02A`,
	"avatar-container__default": `Avatar_avatar-container__default__kzqxs`,
	"avatar-container__small": `Avatar_avatar-container__small__UDJLp`,
	"avatar-container__medium": `Avatar_avatar-container__medium__Kud1R`,
	"avatar-container__large": `Avatar_avatar-container__large__PUdex`,
	"avatar-container__xlarge": `Avatar_avatar-container__xlarge__scjaU`,
	"avatar-container__xxlarge": `Avatar_avatar-container__xxlarge__ijpMP`,
	"avatar-container--square": `Avatar_avatar-container--square__EJjv7`,
	"avatar-container__initials": `Avatar_avatar-container__initials__+ZS5r`,
	"avatar-container__initials--default": `Avatar_avatar-container__initials--default__ATmk9`,
	"avatar-container__initials--small": `Avatar_avatar-container__initials--small__4SFZx`,
	"avatar-container__initials--medium": `Avatar_avatar-container__initials--medium__3qtJp`,
	"avatar-container__initials--large": `Avatar_avatar-container__initials--large__+FKMv`,
	"avatar-container__status": `Avatar_avatar-container__status__S2kXo`,
	"avatar-container__status--offline": `Avatar_avatar-container__status--offline__Iahnn`,
	"avatar-container__status--online": `Avatar_avatar-container__status--online__bSncU`,
	"avatar-container__edit": `Avatar_avatar-container__edit__4GQNZ`
};
export default ___CSS_LOADER_EXPORT___;
